import React from 'react';
import ConfettiExplosion from 'react-confetti-explosion';
export function Finish() {
    const [isExploding, setIsExploding] = React.useState(true);
    return (React.createElement("div", { className: 'register-getting-started' },
        isExploding && React.createElement(ConfettiExplosion, { onComplete: () => setIsExploding(false) }),
        React.createElement("h2", { className: "register-getting-started__title register-thank-you__title" }, "You\u2019re all set!"),
        React.createElement("p", { className: "register-getting-started__description register-thank-you__description" }, "Thank you for placing your order with TrackNotion! You\u2019re now ready to get full access to your dashboard and Start tracking!"),
        React.createElement("a", { href: '/login', className: 'button button--marketing-solid' }, "View dashboard")));
}
